import { render, staticRenderFns } from "./TabType.vue?vue&type=template&id=0bc285ff&scoped=true"
import script from "./TabType.vue?vue&type=script&lang=ts"
export * from "./TabType.vue?vue&type=script&lang=ts"
import style0 from "./TabType.vue?vue&type=style&index=0&id=0bc285ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc285ff",
  null
  
)

export default component.exports